/**
 * probeFlag — 진단 화면의 계측 오버레이를 켜는 스위치.
 *
 * **켜는 자리는 하나다**: 더보기 › 앱 버전 연타로 여는 개발자 옵션
 * (`features/more/debugUnlock.ts`). 예전에는 URL 질의(`?probe=1`)와 빌드 종류(dev 면 기본
 * ON)로도 켜졌는데, 그 빌드로 리뷰하면 측정 화면마다 계측 바가 버튼을 덮었고
 * (TestFlight 3차 #103) 끄는 방법이 화면 안에 없었다. 입구가 하나면 "꺼 뒀는데 켜져 있다"가
 * 생기지 않는다.
 *
 * **왜 저장하냐**: 진단은 여러 화면을 지나며 내부 라우팅을 탄다. 한 번 켜면 끌 때까지 남아야
 * 한 테이크를 끝까지 계측할 수 있다.
 *
 * 저장은 실패해도 무해하다 — 못 읽으면 그냥 꺼진 것이다(사파리 프라이빗 등).
 */

const STORAGE_KEY = 'muzly.captureProbe';

/** 개발자 옵션의 스위치가 쓰는 입구. */
export const setProbe = (on: boolean): void => {
  try {
    localStorage.setItem(STORAGE_KEY, on ? '1' : '0');
  } catch {
    /* 저장 못 하면 이번 화면에서만 산다 */
  }
};

/** 지금 켜져 있나. 저장된 값이 없으면 꺼짐이다(빌드 종류를 보지 않는다). */
export const isProbeOn = (): boolean => {
  try {
    return localStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    return false;
  }
};
